import useAgentura from "./useAgentura";

export default useAgentura;